import React, { useState, useEffect, useCallback } from "react";
import CustomTable from "src/components/App/AppGrid/CustomTable/CustomTable";
import { Avatar, Chip, Box, alpha } from "@mui/material";
import theme from "src/config/theme";
import ButtonComponent from "src/components/shared/Button";
import DialogBox from "src/components/shared/Dialog/DialogBox";
import { ReactComponent as Edit } from '../../../../../assets/images/edit-2.svg';
import { ReactComponent as Delete } from '../../../../../assets/images/trash.svg';
import { ReactComponent as Add } from '../../../../../assets/images/add-square.svg';
import NoDataFound from "../../NoDataFound/NoDataFound";
import useResponsive from "src/components/hooks/useResponsive";
import useAppointmentDetails from "../../UseAppointmentDetails";
import FollowUpTabForm from "../Forms/FollowUpTabForm";
import { getFollowupByPatientIdRequest } from "src/modules/app/store/appActions";
import { useDispatch, useSelector } from "react-redux";
import { AllTabsMainContainer } from "../Style";
import FollowupCard from "../CardView/FollowupCard";

const columns = [
  { id: "totalFollowup", label: "Follow-ups", sx: { width: "350px", textAlign: 'center' } },
  { id: "days", label: "Gap Between Follow-ups", sx: { "& .css-axw7ok": { justifyContent: 'center' } } },
  { id: "status", label: "Status", sx: { "& .css-axw7ok": { justifyContent: 'center' } } },
];

const actions = [

  // { label: "Edit", icon: <Edit />, onClick: (row) => alert(`Viewing ${row.patient}`) },
  // { label: "Delete", icon: <Delete />, onClick: (row) => alert(`Attending ${row.patient}`) },
];

const FollowUps = ({ shouldRefresh }) => {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const { isMobile, isTablet, isDesktop } = useResponsive();
  const dispatch = useDispatch();
  const [followup, setFollowup] = useState([]);
  const { PatientId } = useAppointmentDetails();
  const [page, setPage] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState();

  const fetchFollowUps = useCallback(
    (page = 0, perPage = 10) => {
      const fetchData = async () => {
        const params = {
          page: page + 1,
          limit: perPage,
        };

        const response = await new Promise((resolve, reject) => {
          dispatch(getFollowupByPatientIdRequest({ patientId: PatientId, params }, resolve, reject));
        });

        if (response?.data && response?.meta) {
          setFollowup(response.data);
          setTotalCount(response.meta.totalRecords);

        } else {
          console.log('Error fetching Follow-ups');
        }

      }
      fetchData();

    },
    [dispatch, PatientId],
  );

  useEffect(() => {
    if (PatientId) {
      fetchFollowUps(page, perPage);
    }
  }, [PatientId, fetchFollowUps, page, perPage, shouldRefresh]);
  const data = followup.map((followupData) => ({
    followupId: followupData?.id,
    totalFollowup: followupData.totalFollowup,
    days: followupData.days,
    status: <Chip label="Task Assigned" sx={{
      background: 'linear-gradient(0deg, rgba(103, 57, 150, 0.14), rgba(103, 57, 150, 0.14))',
      color: theme.palette.action.purpleLight,
      ...theme.typography.small,
      borderRadius: '100px',
      padding: '10px 18px 8px 18px',
    }} />,
  }))

  return (
    <>
      <AllTabsMainContainer>
        {(isMobile || isTablet) ?
          <FollowupCard
            followup={followup}
            page={page}
            perPage={perPage}
            setPage={setPage}
            totalCount={totalCount}
            fetchFollowUps={fetchFollowUps}
          /> :
          <CustomTable
            key={page}
            columns={columns}
            data={data}
            actions={actions}
            page={page}
            disabled={true}
            onPageChange={(newPage) => {
              setPage(newPage);
            }}
            onPerPageChange={(newPerPage) => {
              setPerPage(newPerPage);
              setPage(0);
            }}
            perPage={perPage}
            totalCount={totalCount}
            headerButton={
              <ButtonComponent
                variant="contained"
                endIcon={<Add width={isMobile || isTablet ? 18 : 24}
                  height={isMobile || isTablet ? 18 : 24} />}
                onClick={handleOpen}
                sx={{
                  background: theme.palette.primary.main,
                  border: `1px solid ${alpha(theme.palette.gery.black, 0.14)}`,
                  boxShadow: theme.shadows[1],
                  width: '187px',
                  height: '36px',
                  padding: '6px 6px 6px 10px',
                  borderRadius: '12px',
                  ...theme.typography.h5,
                }}
              >Add Follow-UP</ButtonComponent>
            }
            noDataComponent={
              <NoDataFound
                title="No Follow-ups Found!"
                buttonText="Add Follow-up"
                buttonIcon={Add}
                onClick={handleOpen}
              />
            }
          />
        }

        <DialogBox open={open} onClose={handleClose}>
          <FollowUpTabForm onClose={handleClose} fetchFollowUps={fetchFollowUps} />
        </DialogBox>
      </AllTabsMainContainer>
    </>
  )
};

export default FollowUps;

